import { DataConverter } from './DataConverter';
import { DartfishFileConverter } from './Dartfish';
import { LongoFileConverter } from './LongoMatch/LongoFileConverter';
import { SportsCodeFileImporter } from './SportsCode/SportsCodeFileImporter';
import { SportsCodeFileExporter } from './SportsCode/SportsCodeFileExporter';

export const converters: any[] = [
  DataConverter,
  DartfishFileConverter,
  LongoFileConverter,
  SportsCodeFileImporter,
  SportsCodeFileExporter
];

export * from './DataConverter';
export * from './Dartfish';
export * from './LongoMatch/LongoFileConverter';
export * from './SportsCode/SportsCodeFileImporter';
export * from './SportsCode/SportsCodeFileExporter';
